import gql from 'graphql-tag';

export const fields = `
    name
    createdAt
    updatedAt
`;

export const relationsFields = `
`;

// default methods
export const paginationQuery = gql`
    query DigitaiPaginateAircraftStatuses (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        pagination: digitaiPaginateAircraftStatuses (
            query: $query
            constraint: $constraint
        ) {
            total
            rows
            count
        }
    }
`;

export const getQuery = gql`
    query DigitaiGetAircraftStatuses (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        objects: digitaiGetAircraftStatuses (
            query: $query
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const findByIdQuery = gql`
    query DigitaiFindAircraftStatusById (
        $id: ID
        $constraint: QueryStatement
    ) {
        object: digitaiFindAircraftStatusById (
            id: $id
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const findQuery = gql`
    query DigitaiFindAircraftStatus (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        object: digitaiFindAircraftStatus (
            query: $query
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const createMutation = gql`
    mutation DigitaiCreateAircraftStatus (
        $payload: DigitaiCreateAircraftStatusInput!
    ) {
        digitaiCreateAircraftStatus (
            payload: $payload
        ) {
            ${fields}
        }
    }
`;

export const updateByIdMutation = gql`
    mutation DigitaiUpdateAircraftStatusById (
        $payload: DigitaiUpdateAircraftStatusByIdInput!
        $constraint: QueryStatement
    ) {
        digitaiUpdateAircraftStatusById (
            payload: $payload
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const updateMutation = gql`
    mutation DigitaiUpdateAircraftStatuses (
        $payload: DigitaiUpdateAircraftStatusesInput!
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiUpdateAircraftStatuses (
            payload: $payload
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteByIdMutation = gql`
    mutation DigitaiDeleteAircraftStatusById (
        $id: ID!
        $constraint: QueryStatement
    ) {
        digitaiDeleteAircraftStatusById (
            id: $id
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteMutation = gql`
    mutation DigitaiDeleteAircraftStatuses (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiDeleteAircraftStatuses (
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;
